import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid2,
  IconButton,
  TextField,
  useTheme,
} from "@mui/material";
import * as React from "react";
import { IoMdClose } from "react-icons/io";
import { useUpdateWorkFlowMilestoneMutation } from "store/slices/apis/keyMilestoneSlice";

export default function ApproveMilestoneComponent(props) {
  const {
    open,
    cancel,
    rowData,
    fullObjectData,
    type,
    openNotification,
    refetch,
  } = props;
  const theme = useTheme();
  const [comment, setComment] = React.useState("");

  const [updateWorkFlowMilestone, updateWorkFlowMilestoneRes] = useUpdateWorkFlowMilestoneMutation();
  const handleApprove = () => {
    let formData = {
      id: fullObjectData?.id,
      parentId: rowData?.id,
      status: "Approved",
      type: "Milestone",
      actionTaken: "Updated",
      data: JSON.stringify(rowData),
      actionDate:fullObjectData?.actionDate,
      comment:fullObjectData?.comment,
      createdDate:fullObjectData?.createdDate,
    };
    updateWorkFlowMilestone(formData);
  };

  React.useEffect(() => {
    if (updateWorkFlowMilestoneRes?.isSuccess) {
      if (updateWorkFlowMilestoneRes?.data?.status == "Success") {
        openNotification(updateWorkFlowMilestoneRes?.data?.message, "success");
        setComment("");
        cancel();
        refetch();
      } else {
        openNotification(updateWorkFlowMilestoneRes?.data?.message, "error");
      }
    }
  }, [updateWorkFlowMilestoneRes?.isSuccess]);
  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={cancel}
        disableEnforceFocus
        disableRestoreFocus
        aria-labelledby="draggable-dialog-title"
        fullWidth={true}
        maxWidth={"sm"}
      >
        <DialogTitle
          sx={{
            fontWeight: 500,
            fontSize: "20px",
            color: "#252525",
            paddingBottom: 0,
          }}
          id="draggable-dialog-title"
        >
          Approve
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={cancel}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          }}
        >
          <IoMdClose style={{ fontSize: "20px" }} />
        </IconButton>
        <DialogContent>
          <DialogContentText
            sx={{ fontWeight: 400, fontSize: "16px", color: "#474747" }}
          >
            Are you sure you want to approve this Actual Finish Date ? This
            action is permanent.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            onClick={handleApprove}
            loading={updateWorkFlowMilestoneRes?.isLoading}
            sx={{
              backgroundColor: `${theme?.customSettings?.themeColor}`,
              color: "#fff",
              fontSize: "16px",
              fontWeight: "500",
              textTransform: "none",
            }}
          >
            Approve
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
